interface ApparelSeller {
  id: string;
  organization: string;
  contactName: string;
  designation?: string;
  address?: string;
  email?: string;
  mobile?: string;
  industryType: string; // K = Knitwear, W = Woven, S = Sweaters
  products: string;
  slug: string;
  subdomain: string;
  verified: boolean;
  yearEstablished?: number;
  rating: number;
  totalProducts: number;
  description: string;
  specialties: string[];
  location: string;
  city: string;
  avatar?: string;
  status?: string;
  created_at?: string;
  reviews?: number;
}

export const apparelSellers: ApparelSeller[] = [
  {
    id: 'app-1',
    organization: 'Dhaka Knitwear Ltd.',
    contactName: 'Mr. Rashid',
    designation: 'Export Manager',
    address: 'Plot 45, Sector 7, Dhaka EPZ',
    email: 'export@dhakaknitwear.com',
    mobile: '+880-1711-234567',
    industryType: 'K',
    products: 'T-Shirts, Polo Shirts, Tank Tops, Hoodies',
    slug: 'dhaka-knitwear',
    subdomain: 'dhakaknitwear.madeinbd.com',
    verified: true,
    yearEstablished: 1995,
    rating: 4.8,
    totalProducts: 145,
    description: 'Leading knitwear manufacturer specializing in cotton and cotton blend garments.',
    specialties: ['Cotton T-Shirts', 'Polo Shirts', 'Hoodies', 'Tank Tops'],
    location: 'Dhaka, Bangladesh',
    city: 'Dhaka',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-01-10T00:00:00Z',
    reviews: 234
  },
  {
    id: 'app-2',
    organization: 'Chittagong Woven Fabrics',
    contactName: 'Ms. Sultana',
    designation: 'Managing Director',
    address: '78 Woven Street, Chittagong 4000',
    email: 'info@chittagongwoven.com',
    mobile: '+880-1812-345678',
    industryType: 'W',
    products: 'Shirts, Trousers, Jackets, Formal Wear',
    slug: 'chittagong-woven',
    subdomain: 'chittagongwoven.madeinbd.com',
    verified: true,
    yearEstablished: 1988,
    rating: 4.7,
    totalProducts: 189,
    description: 'Premium woven garments manufacturer with state-of-the-art facilities.',
    specialties: ['Formal Shirts', 'Trousers', 'Jackets', 'Business Wear'],
    location: 'Chittagong, Bangladesh',
    city: 'Chittagong',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-02-15T00:00:00Z',
    reviews: 198
  },
  {
    id: 'app-3',
    organization: 'Sylhet Sweater Mills',
    contactName: 'Mr. Hoque',
    designation: 'Production Manager',
    address: '234 Sweater Lane, Sylhet 3100',
    email: 'orders@sylhetsweater.com',
    mobile: '+880-1921-456789',
    industryType: 'S',
    products: 'Sweaters, Cardigans, Pullovers, Winter Wear',
    slug: 'sylhet-sweater',
    subdomain: 'sylhetsweater.madeinbd.com',
    verified: true,
    yearEstablished: 2000,
    rating: 4.6,
    totalProducts: 78,
    description: 'Specialized sweater manufacturer with expertise in winter garments.',
    specialties: ['Sweaters', 'Cardigans', 'Pullovers', 'Winter Wear'],
    location: 'Sylhet, Bangladesh',
    city: 'Sylhet',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-03-20T00:00:00Z',
    reviews: 167
  },
  {
    id: 'app-4',
    organization: 'Gazipur Garments Hub',
    contactName: 'Ms. Begum',
    designation: 'CEO',
    address: '567 Industrial Area, Gazipur 1700',
    email: 'ceo@gazipurgarments.com',
    mobile: '+880-1734-567890',
    industryType: 'KW',
    products: 'Mixed Garments, Uniforms, Workwear, Casual Clothing',
    slug: 'gazipur-garments',
    subdomain: 'gazipurgarments.madeinbd.com',
    verified: true,
    yearEstablished: 2003,
    rating: 4.5,
    totalProducts: 203,
    description: 'Comprehensive garment manufacturer offering both knit and woven products.',
    specialties: ['Uniforms', 'Workwear', 'Casual Clothing', 'Mixed Garments'],
    location: 'Gazipur, Bangladesh',
    city: 'Gazipur',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-04-25T00:00:00Z',
    reviews: 145
  },
  {
    id: 'app-5',
    organization: 'Narayanganj Textile Co.',
    contactName: 'Mr. Islam',
    designation: 'Export Director',
    address: '890 Textile Hub, Narayanganj 1400',
    email: 'export@narayangangtextile.com',
    mobile: '+880-1845-678901',
    industryType: 'KWS',
    products: 'All Types of Garments, Fashion Wear, Trendy Clothing',
    slug: 'narayanganj-textile',
    subdomain: 'narayangangtextile.madeinbd.com',
    verified: true,
    yearEstablished: 1985,
    rating: 4.9,
    totalProducts: 267,
    description: 'Full-service textile manufacturer with comprehensive production capabilities.',
    specialties: ['Fashion Wear', 'Trendy Clothing', 'All Garment Types'],
    location: 'Narayanganj, Bangladesh',
    city: 'Narayanganj',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-05-30T00:00:00Z',
    reviews: 289
  }
];

// Helper functions
export const searchApparelSellers = (query: string): ApparelSeller[] => {
  return apparelSellers.filter(seller =>
    seller.organization.toLowerCase().includes(query.toLowerCase()) ||
    seller.products.toLowerCase().includes(query.toLowerCase()) ||
    seller.specialties.some(specialty => 
      specialty.toLowerCase().includes(query.toLowerCase())
    )
  );
};

export const getApparelSellersByIndustryType = (type: string): ApparelSeller[] => {
  return apparelSellers.filter(seller => 
    seller.industryType.includes(type)
  );
};

export const getApparelSellersByProduct = (product: string): ApparelSeller[] => {
  return apparelSellers.filter(seller =>
    seller.products.toLowerCase().includes(product.toLowerCase()) ||
    seller.specialties.some(specialty => 
      specialty.toLowerCase().includes(product.toLowerCase())
    )
  );
};

const getApparelSellerBySlug = (slug: string): ApparelSeller | undefined => {
  return apparelSellers.find(seller => seller.slug === slug);
};